import AdvancedSearch from "@AdvancedSearch/views/AdvancedSearch.vue";

export default [
  {
    path: "/app/advanced-search",
    name: "advanced-search",

    component: AdvancedSearch
  }
];
